/* =============================================================================
   efectos.js — Los efectos pesados se cargan DESPUÉS del hero
   Hotel La Gruta · Arequipa · 2026-10-21

   La vegetación, la luz, GSAP y las escenas de scroll suman ~190 KB (gzip) en
   catorce archivos. Como <script defer> el navegador los pedía con el HTML y
   repartía el ancho de banda con la imagen del hero (LCP): medido en 3G
   simulado, el hero tardaba 3,3 s en llegar aunque se pidiera a los 0,2 s.
   Aquí se piden sólo cuando el hero ya cargó (o falló) y el DOM está listo,
   en el orden de la lista y sin bloquear nada (async = false conserva el
   orden entre scripts dinámicos). En una conexión rápida el hero llega en
   décimas y no cambia nada; en una lenta, primero la foto, después el jardín.

   La lista vive en cada página: <script type="application/json"
   id="efectos-diferidos">["/assets/js/…", …]</script>. No es un <script>
   real: el navegador no lo pide ni lo ejecuta. scripts/versionar.mjs le pone
   ?v= a esas rutas como a las demás. Los scripts de la lista corren siempre
   después de DOMContentLoaded (window.DOM_CARGADO = true): los que esperaban
   ese evento lo comprueban (vines.js, scroll-fx.js, welcome-tipografia.js).
   Se inyectan antes de `load`: el hero es parte de la carga y un script
   dinámico insertado antes de `load` lo retrasa, así que `load` sigue
   llegando después de ellos.

   Excepción (2026-10-21): al llegar desde otra página del sitio, la luz
   (luz.js y botanic-lib.js, del que depende) no espera al hero, sólo al
   DOM. Esos dos se piden en todas las páginas, así que ya están en la caché
   y no le quitan ancho de banda a la foto; esperándola, la página quedaba
   hasta ~2 s sin luz (4G simulado) y se encendía de golpe. Van primero y el
   resto conserva su orden detrás de ellos.
   ============================================================================= */
(function () {
  'use strict';
  var nodo = document.getElementById('efectos-diferidos');
  if (!nodo) return;
  var lista;
  try { lista = JSON.parse(nodo.textContent); } catch (e) { return; }
  if (!Array.isArray(lista) || !lista.length) return;

  // INTERRUPTOR DE LA VEGETACIÓN (2026-10-22, pedido del usuario: apagada en
  // todo el sitio). Con false no se piden ni se ejecutan la capa vegetal
  // (vines.js), su motor (enredadera-motor.js) ni el jardín del preloader
  // (preloader-jardin.js): cero descarga y cero trabajo. Todo lo que los usa
  // los trata como opcionales (app.js revela sin el jardín, scroll-fx.js y
  // luz.js siguen sin la capa). botanic-lib.js se carga igual: luz.js la usa
  // para las sombras de hojas. Para volver a encenderla: true.
  var VEGETACION = false; // 2026-10-30 (pedido del usuario): vegetación apagada «por ahora»; true + generar:idiomas para encenderla
  var SOLO_VEGETACION = /\/(vines|enredadera-motor|preloader-jardin)\.js(\?|$)/;
  if (!VEGETACION) lista = lista.filter(function (src) { return !SOLO_VEGETACION.test(src); });

  var LUZ = /\/(botanic-lib|luz)\.js(\?|$)/;
  var interna = false;
  try { interna = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) { /* referrer ilegible: como una entrada directa */ }
  var primero = interna ? lista.filter(function (src) { return LUZ.test(src); }) : [];
  var resto = lista.filter(function (src) { return primero.indexOf(src) < 0; });

  function cargar(srcs) {
    window.DOM_CARGADO = true;
    srcs.forEach(function (src) {
      var s = document.createElement('script');
      s.src = src; s.async = false;
      document.head.appendChild(s);
    });
  }
  function domListo() {
    return new Promise(function (ok) {
      // Este archivo corre con defer, antes de DOMContentLoaded: así los
      // scripts estáticos que quedan (app.js…) terminan antes que la lista.
      if (document.readyState === 'complete') return ok();
      document.addEventListener('DOMContentLoaded', ok, { once: true });
    });
  }
  function heroListo() {
    return new Promise(function (ok) {
      var img = document.querySelector('.page.active .hero-media img, .hero-media img');
      if (!img || img.complete) return ok();
      img.addEventListener('load', ok, { once: true });
      img.addEventListener('error', ok, { once: true });
      // Techo: si el hero no responde, los efectos no esperan para siempre.
      setTimeout(ok, 4000);
    });
  }
  // async = false ordena todos los scripts dinámicos por inserción: los de
  // la luz, insertados antes, también se ejecutan antes que el resto.
  if (primero.length) domListo().then(function () { cargar(primero); });
  Promise.all([domListo(), heroListo()]).then(function () { cargar(resto); });
})();
